<script>
import Layout from "../../layouts/main";
import appConfig from "@/app.config";
import apigeneric from "@/helpers/apigeneric";
import Loader from "@/components/widgets/loader";
import Banner from "../components/banner";

export default {
  page: {
    title: process.env.VUE_APP_NAME,
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  components: {
    Layout,
    Loader,
    Banner

  },
  mixins: [apigeneric],
  data() {
    return {
      DefaultPage: 1,
      Page: {
        PageNumber: "1",
        PageSize: "10",
        PageDataSize: "1",
      },
      title: this.$t('StrAnasayfa.Title'),
      PagesData: {},
      LangId: this.$route.params.LangId,
      DpagesId: this.$route.params.DpagesId,
      items: [

        {
          text: this.$t('StrAnasayfa.Title'),
          active: true,
        },
      ],
      fetchingStats: true,
    };
  },
  methods: {
    Get() {
      if (this.LangId == "tr") {
        this.ActionsSingleGet({
          Service: "dpages",
          Id: this.DpagesId
        }).then((res) => {
          this.PagesData = res.Data;
        });
      } else {

        this.ActionsFilterGet({
          Service: "languages",
          Page: this.Page,
          Filter:
            "&shortlangtitle=" + this.LangId
        }).then((res) => {
          for (let LangData in res.Data) {
            this.ActionsFilterGet({
              Service: "dpagetranslations",
              Page: this.Page,
              Filter: "&Langid=" + res.Data[LangData].Id + "&Dpageid=" + this.DpagesId
            }).then((res) => {
              this.PagesData = res.Data[0];

            });
          }

        });

      }
    }
  },
};
</script>
    
<template>
  <Loader>
    <Layout>
      <Banner />
      <div class="news-detail">
        <div class="title c-flex flex-column mb-2">
          <h2>{{PagesData.Title}}</h2>
        </div>
        <div class="container">
          <div class="row">
            <div class="col-md-10 mx-auto">
              <div class="news">
                <div class="image">
                  <img :src="$config.FILES_URL + 'web/' + PagesData.Imagegallery" alt="">
                </div>
                <div class="new-header justify-content-end">
                  <div class="new-date">
                    <span class="date">{{PagesData.Created | formatDateTime}}</span>
                  </div>
                </div>
                <div class="new-content">
                  <span v-html="PagesData.Description"></span><br />
                </div>

              </div>
            </div>

          </div>
        </div>
      </div>
    </Layout>
  </Loader>
</template>
    